export default "__VITE_ASSET__BzVEAFbv__"